import colors from '../tokens/colors';

export const radioGetolo = {
  base: {
    height: 24,
    width: 24,
    fill: colors.PROFESSIONAL_BLUE,
    circle: {
      cx: 12,
      cy: 12,
      r: 11.5,
    },
    dot: {
      cx: 12,
      cy: 12,
      rx: 8,
      ry: 8,
    },
    label: {
      color: colors.PROFESSIONAL_BLUE,
      typography: 'body',
    },
    subLabel: {
      color: colors.PROFESSIONAL_BLUE,
      typography: 'subText',
    },
    stroke: {
      color: colors.PROFESSIONAL_LIGHT_BLUE,
      width: 1,
    },
  },
  states: {
    hover: {},
    focusVisible: {
      outline: `3px solid ${colors.PROFESSIONAL_BLUE}`,
      outlineOffset: 1.5,
      strokeWidth: 1,
    },
    checked: {
      stroke: colors.PROFESSIONAL_BLUE,
    },
    disabled: {
      labelColor: colors.GRAY,
      subLabelColor: colors.GRAY,
    },
  },
};

export const radioDaDirekt = {
  base: {
    height: 24,
    width: 24,
    fill: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    circle: {
      cx: 12,
      cy: 12,
      r: 11,
    },
    dot: {
      cx: 12,
      cy: 12,
      rx: 8,
      ry: 8,
    },
    label: {
      color: colors.PROFESSIONAL_BLUE,
      typography: 'body',
    },
    subLabel: {
      color: colors.DA_DIREKT_DARK_BLUE_80,
      typography: 'subText',
    },
    stroke: {
      color: colors.DA_DIREKT_BORDER_LINES,
      width: 2,
    },
  },
  states: {
    hover: {},
    focusVisible: {
      outline: `2px solid ${colors.DA_DIREKT_VISUAL_BRAND_ORANGE}`,
      outlineOffset: 2,
      strokeWidth: 2,
    },
    checked: {
      stroke: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    },
    disabled: {
      labelColor: colors.PRODUCT_BLUE,
      subLabelColor: colors.PRODUCT_BLUE,
    },
  },
};

export const radioDaKaufland = {
  base: {
    height: 22,
    width: 22,
    fill: colors.DA_KAUFLAND_BLACK,
    circle: {
      cx: 11,
      cy: 11,
      r: 9,
    },
    dot: {
      cx: 11,
      cy: 11,
      rx: 5,
      ry: 5,
    },
    label: {
      color: colors.DA_KAUFLAND_BLACK,
      typography: 'p4',
    },
    subLabel: {
      color: colors.DA_KAUFLAND_BLACK,
      typography: 'p4',
    },
    stroke: {
      color: colors.DA_KAUFLAND_GRAY_1,
      width: 2,
    },
  },
  states: {
    hover: {},
    focusVisible: {
      outline: `2px solid ${colors.DA_KAUFLAND_RED}`,
      outlineOffset: 0,
      strokeWidth: 2,
    },
    checked: {
      stroke: colors.DA_KAUFLAND_GRAY_1,
    },
    disabled: {
      labelColor: colors.DA_KAUFLAND_BLACK,
      subLabelColor: colors.DA_KAUFLAND_BLACK,
    },
  },
};

export const radioFressnapf = {
  base: {
    height: 24,
    width: 24,
    fill: colors.FRESSNAPF_PRIMARY,
    circle: {
      cx: 12,
      cy: 12,
      r: 11.5,
    },
    dot: {
      cx: 12,
      cy: 12,
      rx: 8,
      ry: 8,
    },
    label: {
      color: colors.FRESSNAPF_TEXT_PRIMARY,
      typography: 'body',
    },
    subLabel: {
      color: colors.FRESSNAPF_TEXT_SECONDARY,
      typography: 'subText',
    },
    stroke: {
      color: colors.FRESSNAPF_TEXT_SECONDARY,
      width: 1,
    },
  },
  states: {
    hover: {
      circle: {
        fill: colors.FRESSNAPF_HOVER,
      },
    },
    focusVisible: {
      outline: 'none',
      outlineOffset: 0,
      strokeWidth: 2,
    },
    checked: {
      stroke: colors.FRESSNAPF_TEXT_PRIMARY,
    },
    disabled: {
      labelColor: colors.FRESSNAPF_TEXT_PRIMARY,
      subLabelColor: colors.FRESSNAPF_TEXT_PRIMARY,
    },
  },
};
